import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { CKBox, CKButton, CKDrawer } from 'clearkit';

import TextField from '~/components/RedesignedTextField';

import CheckboxActive from './CheckboxActive.svg';
import CheckboxInactive from './CheckboxInactive.svg';
import styles from './styles';

function PlanOption({ name, description, classes, checked, onChange }) {
  return (
    <div className={classes.planOption}>
      <Checkbox
        checked={checked}
        checkedIcon={<CheckboxActive />}
        classes={{ root: classes.checkbox }}
        icon={<CheckboxInactive />}
        onChange={(event) => onChange(event.target.checked)}
        value={name.toLowerCase()}
      />
      <div>
        <span className={classes.optionName}>{name}</span>
        <p className={classes.optionDescription}>{description}</p>
      </div>
    </div>
  );
}

export function isValid(values) {
  const anOptionSelected =
    values.advertising ||
    values.personalization ||
    values.alerting ||
    values.enrichment_salesforce ||
    values.enrichment_hubspot ||
    values.enrichment_marketo ||
    values.enrichment_segment;

  return values.email !== '' && values.name !== '' && anOptionSelected;
}

function RequestAccessForm({
  classes,
  values,
  onChange,
  onClose,
  valid,
  onSubmit,
  product,
}) {
  return (
    <form className="flex flex-col overflow-hidden" onSubmit={onSubmit}>
      <CKDrawer.Body className="p-6">
        <CKBox variant="card">
          <div className={classes.contactInfo}>
            <FormControl className={classes.field} fullWidth>
              <FormLabel>Email address*</FormLabel>
              <TextField
                onChange={(event) => onChange('email', event.target.value)}
                value={values.email}
              />
            </FormControl>

            <FormControl className={classes.field} fullWidth>
              <FormLabel>Name*</FormLabel>
              <TextField
                onChange={(event) => onChange('name', event.target.value)}
                value={values.name}
              />
            </FormControl>
          </div>

          <div className={classes.planOptions}>
            <p className={classes.choosePlan}>
              Choose the plans you&apos;d like to add to your account
            </p>
            {product === 'dataEnrichment' ? (
              <>
                <PlanOption
                  checked={values.enrichment_salesforce}
                  classes={classes}
                  description="Enrich any account, contact, or lead, or your full database of records, within Salesforce."
                  name="Salesforce enrichment"
                  onChange={(value) => onChange('enrichment_salesforce', value)}
                />

                <PlanOption
                  checked={values.enrichment_marketo}
                  classes={classes}
                  description="Enrich any account, contact, or lead, or your full database of records, within Marketo."
                  name="Clearbit for Marketo"
                  onChange={(value) => onChange('enrichment_marketo', value)}
                />

                <PlanOption
                  checked={values.enrichment_hubspot}
                  classes={classes}
                  description="Enrich and refresh new contacts, form submissions, or your entire contact database within HubSpot."
                  name="Clearbit for Hubspot"
                  onChange={(value) => onChange('enrichment_hubspot', value)}
                />

                <PlanOption
                  checked={values.enrichment_segment}
                  classes={classes}
                  description="Enrich people and companies in Segment with Clearbit data."
                  name="Clearbit for Segment"
                  onChange={(value) => onChange('enrichment_segment', value)}
                />
              </>
            ) : (
              <>
                <PlanOption
                  checked={values.alerting}
                  classes={classes}
                  description="Send alerts to your team via destinations like Slack, Salesforce, Email or Webhooks when a person or company matches an audience."
                  name="Alerting"
                  onChange={(value) => onChange('alerting', value)}
                />

                <PlanOption
                  checked={values.advertising}
                  classes={classes}
                  description="Automatically create highly targeted ads audiences when a person or company matches an audience."
                  name="Advertising"
                  onChange={(value) => onChange('advertising', value)}
                />

                <PlanOption
                  checked={values.personalization}
                  classes={classes}
                  description="Use Clearbit Audiences to customize your website in realtime."
                  name="Personalization"
                  onChange={(value) => onChange('personalization', value)}
                />
              </>
            )}
          </div>

          <div className={classes.message}>
            <FormControl className={classes.field} fullWidth>
              <FormLabel className="mb-2 font-semibold">Message</FormLabel>
              <TextField
                InputProps={{ rel: 'message' }}
                multiline
                onChange={(event) => onChange('message', event.target.value)}
                placeholder="Let us know a little more about what you're aiming to accomplish and if you have any additional requirements."
                rows={3}
                value={values.message}
              />
            </FormControl>
          </div>
        </CKBox>
      </CKDrawer.Body>
      <CKDrawer.Footer className="gap-3">
        <CKButton onClick={onClose}>Cancel</CKButton>
        <CKButton
          isDisabled={!valid}
          type="submit"
          variant="bold"
          variantColor="blue"
        >
          Submit
        </CKButton>
      </CKDrawer.Footer>
    </form>
  );
}

RequestAccessForm.propTypes = {
  classes: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  values: PropTypes.object,
  onChange: PropTypes.func,
  valid: PropTypes.bool,
};

export default withStyles(styles)(RequestAccessForm);
